import React from "react";
import { get } from "lodash";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import Delete from "@mui/icons-material/Delete";
import BSInput from "../../../common/js/components/BSInput";
import "./Portfolio.css";

const CenterCell = styled("div")({
    textAlign: "center",
    fill: "#9e9e9e",
});

const ShrinkButton = styled(Button)({
    padding: 0,
    minWidth: 0,
    minHeight: 0,
    margin: 0,
    color: "#9e9e9e",
    "&:hover": {
        backgroundColor: "transparent",
    },
});

const PortfolioPropertyDetail = (props) => {
    const { dataPathPrefix, disableInputs, element, elementIndex, errors, handleUpdateArrayElement, onDelete } = props;

    return (
        <div>
            <div className={elementIndex === 0 ? "portfolioFlexContainer" : "portfolioFlexContainerWElementIndex"}>
                <BSInput
                    id="propertyId"
                    label={elementIndex === 0 ? "Property ID" : null}
                    errorText="(ex. 98101)"
                    placeholder="Enter property ID"
                    value={element ? element.propertyId : null}
                    error={get(errors, `portfolioProperties.${elementIndex}.propertyId`, null)}
                    onChange={(e) =>
                        handleUpdateArrayElement(
                            dataPathPrefix + ".portfolioProperties",
                            elementIndex,
                            e.target.id,
                            e.target.value
                        )
                    }
                    disabled={disableInputs}
                />
                <CenterCell>
                    {elementIndex > 0 && disableInputs !== true && (
                        <ShrinkButton onClick={() => onDelete(elementIndex)}>
                            <Delete />
                        </ShrinkButton>
                    )}
                </CenterCell>
            </div>
        </div>
    );
};

export default PortfolioPropertyDetail;
